import { Flex, Spacer, Center, Box, Text, Image, Button, MenuItem, 
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup, useDisclosure } from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import Jazzicon from "react-jazzicon"
import CartList from './CartList'
import { chainsList } from '../assets/js/chain_list'
import { chains } from '../assets/js/chains'
import { useState, useEffect, useRef } from 'react';
import { connectWallet, contract } from '../utils/connectWallet'
import { walletSwitchChain } from '../utils/walletSwitchChain'
import { ethers } from 'ethers'
import { contractData } from '../assets/js/contract'
import {getLs, setLs} from '../service/service'
import { useStore, useDispatch } from '../store/Context';
import { createStandaloneToast } from '@chakra-ui/toast'
const { toast } = createStandaloneToast()
function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { cartList } = useStore()
  const btnRef = useRef()
  const dispatch = useDispatch()
  const [state, setState] = useState({
    chain: chainsList[0],
    balanceInEth: 0,
    account: ''
  })

  let click = (e) => {
    let chain = e
    walletSwitchChain(chain.chainId).then(() => {
      let data = Object.assign(state, {chain})
      setState({...data})
    }).catch(err => {
      console.log(err)
      toast({
        title: '切换失败',
        position: 'top',
        isClosable: true,
        status: 'error'
      })
    })
  }
  let fn = () => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        console.log("账号切换", accounts[0])
        getData()
      })
      window.ethereum.on("chainChanged", (chainId) => {
        console.log("用户切换了链", chainId);
        getData()
      })
    }
  }
  let getData = async () => {
    try {
      let web3 = await connectWallet()
      let accounts = await web3.listAccounts()
      let account = ''
      let balanceInEth = 0
      if (accounts.length) {
        account = accounts[0]
        let balance = await web3.getBalance(account)
        balanceInEth = ethers.utils.formatEther(balance)
        balanceInEth = (+balanceInEth).toFixed(2)
      }
      let network = await web3.getNetwork()
      let chainId = network.chainId
      let chain = chains.filter(e => e.chainId == chainId)[0]
      setState({...Object.assign(state, {account, balanceInEth, chain})})
      let C = await contract(contractData.contractAddress, contractData.abi, web3.getSigner())
      dispatch({ type: "updateContract", contractData: C, userAddress: account});
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getData()
    fn()
  }, [])
  return (
    <>
      <Flex h="64px" marginBottom="100px" padding='0 20px' boxSizing='border-box'>
        <Center fontSize='28px' fontWeight='550' fontFamily='Baskerville' cursor='pointer'>
          Portal3.to
          {/* <img src={logo} style={{width: '140px'}}></img> */}
        </Center>
        <Spacer />
        <Flex h="64px" alignItems='center'>
          <Flex ref={btnRef} onClick={onOpen} width='60px' alignItems='center'>
            <svg t="1658855557901" cursor='pointer'  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8505" width="24" height="24"><path d="M352.456912 832.032253c-35.434907 0-63.989249 28.554342-63.989249 63.989249 0 35.434907 28.554342 63.989249 63.989249 63.989249s63.989249-28.554342 63.989249-63.989249C416.446162 860.586595 387.891819 832.032253 352.456912 832.032253L352.456912 832.032253z" p-id="8506" fill="#1a202c"></path><path d="M800.55367 832.032253c-35.434907 0-63.989249 28.554342-63.989249 63.989249 0 35.434907 28.554342 63.989249 63.989249 63.989249s63.989249-28.554342 63.989249-63.989249C864.54292 860.586595 835.816563 832.032253 800.55367 832.032253L800.55367 832.032253z" p-id="8507" fill="#1a202c"></path><path d="M864.026877 800.037628 344.200235 800.037628c-46.099782 0-86.695112-36.466991-92.199563-83.082815l-54.356459-382.043339L166.853687 156.360826c-1.892155-15.653284-16.169326-28.382328-29.930455-28.382328L95.983874 127.978498c-17.717453 0-31.994625-14.277171-31.994625-31.994625s14.277171-31.994625 31.994625-31.994625l40.767344 0c46.615824 0 87.727196 36.466991 93.403662 83.082815l30.790526 177.86259L315.473879 708.698135c1.720141 14.793214 15.309256 27.350244 28.726356 27.350244l519.826642 0c17.717453 0 31.994625 14.277171 31.994625 31.994625S881.744331 800.037628 864.026877 800.037628z" p-id="8508" fill="#1a202c"></path><path d="M384.279523 672.05913c-16.685369 0-30.618512-12.729044-31.82261-29.586427-1.376113-17.545439 11.868974-33.026709 29.586427-34.230808l434.163615-31.994625c15.997312-0.172014 29.414413-12.55703 31.134554-26.834201l50.400134-288.295649c1.204099-10.664875-1.720141-22.533848-8.084663-29.758441-4.128339-4.644381-9.288762-7.052579-15.309256-7.052579L319.946246 224.3064c-17.717453 0-31.994625-14.277171-31.994625-31.994625S302.400806 159.973123 319.946246 159.973123l554.05745 0c24.426004 0 46.959852 10.148833 63.301193 28.554342 18.749538 21.157736 27.178229 50.744163 23.565933 81.706703l-50.400134 288.467663c-5.504452 44.895683-45.927768 81.362674-92.027549 81.362674l-431.755417 31.82261C385.82765 671.887116 384.967579 672.05913 384.279523 672.05913z" p-id="8509" fill="#1a202c"></path></svg>
            {
              cartList && cartList.length ? (
                <Text marginLeft='6px'>{cartList.length}</Text>
              ) : ''
            }
          </Flex>
          <Menu closeOnSelect={true}>
            <MenuButton as={Button} rightIcon={<ChevronDownIcon />} backgroundColor='#FFF' borderWidth='1px' borderRadius='10px' >
              <Flex alignItems='center'>
                <img src={state.chain.icon ? `https://defillama.com/chain-icons/rsz_${state.chain.icon}.jpg` : 'https://chainlist.org/unknown-logo.png'} style={{width: '16px', height: '16px', borderRadius: '10px'}}></img>
                <Text marginLeft='8px'>{state.chain.name}</Text>
              </Flex>
            </MenuButton>
            <MenuList h='300px' overflow='auto'>
              <MenuOptionGroup type='radio'>
                {
                  chainsList.map(e => (
                    <MenuItemOption key={e.chainId} value={e.name} onClick={() => click(e)}>
                      <Flex alignItems='center'>
                        <img src={e.icon ? `https://defillama.com/chain-icons/rsz_${e.icon}.jpg` : 'https://chainlist.org/unknown-logo.png'} style={{width: '16px', height: '16px', borderRadius: '10px'}}></img>
                        <Text marginLeft='8px'>{e.name}</Text>
                      </Flex>
                    </MenuItemOption>
                  ))
                }
                {/* <MenuItemOption value='phone'>Phone</MenuItemOption>
                <MenuItemOption value='country'>Country</MenuItemOption> */}
              </MenuOptionGroup>
            </MenuList>
          </Menu>
          <Flex marginLeft='20px' alignItems='center' height='40px' borderWidth='1px' borderRadius='10px' padding='0 1px 0 12px'>
            <Text fontSize='16px' fontWeight='600'>{state.balanceInEth} {state.chain.network && state.chain.network == 'testnet' ? `${state.chain.name[0].toLocaleLowerCase()}${state.chain.chain}` : state.chain.chain}</Text>
            <Flex marginLeft='12px' height='36px' alignItems='center' backgroundColor='#F7F8FA' borderWidth='1px' borderRadius='10px' padding='0 6px'>
              <Text marginRight='12px'>{`${state.account.slice(0, 6)}...${state.account.slice(-4)}`}</Text> 
              <Jazzicon
                diameter={20}
                seed={parseInt(state.account.slice(2, 10), 16)}
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <CartList 
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
        dataList={cartList}
      /> 
    </>
  );
}

export default Header;
